import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="container">
      <div className="card">
        <h2>404 — Not Found</h2>
        <p>We cannot find the page you are looking for.</p>
        <Link className="link" to="/">Go Home</Link>
      </div>
    </div>
  );
};
export default NotFound;
